import { findDOMNode } from "react-dom";

import { ConstraintTarget } from "../../constants/constraints";
import dateFunctions from "../../modules/definition/calendar/dateFunctions";
import { stringFromDate } from "../../modules/definition/calendar/dateFunctions/stringFromDate";
import { getPointerPositionInDOMElement } from "../../utils/mouseUtils";

const getTickKey = tick => `${tick.pixel}-${tick.label}`;

const getDropDateResult = (calendar, dropTs, unitScale, snapToTimespan) => {
  const exactDate = dateFunctions.dateWithTimestamp(calendar, dropTs);
  const roundedDate = dateFunctions.roundedDateForScale(calendar, exactDate, unitScale, snapToTimespan);

  return {
    newDate: roundedDate,
    dateString: stringFromDate(calendar, roundedDate)
  };
};

const getMouseTimespan = (mouseEvent, node, viewportLeft, zoom) => {
  const mouseXInHeader = getPointerPositionInDOMElement(mouseEvent, findDOMNode(node)).x;
  const scrollLeft = viewportLeft;
  const unitScale = zoom;
  const mouseAbsX = scrollLeft + mouseXInHeader;
  return Math.round(mouseAbsX * unitScale);
};

const ordinalString = n => {
  const lastDigit = n % 10;
  const lastTwoDigits = n % 100;
  if (lastDigit == 1 && lastTwoDigits != 11) {
    return `${n}st`;
  } else if (lastDigit == 2 && lastTwoDigits != 12) {
    return `${n}nd`;
  } else if (lastDigit == 3 && lastTwoDigits != 13) {
    return `${n}rd`;
  }
  return `${n}th`;
};

const getIsDependencyStart = (dep, isSubject) => {
  if (!dep) {
    return false;
  }
  return isSubject ? dep.dependencyType.startsWith("S") : dep.dependencyType.endsWith("S");
};

const getIsConstraintStart = (constraint, isSubject) => {
  if (!constraint) {
    return false;
  }
  return isSubject
    ? constraint.subjectTarget === ConstraintTarget.Start
    : constraint.objectTarget === ConstraintTarget.Start;
};

const timelineViewUtils = {
  getTickKey,
  getDropDateResult,
  getMouseTimespan,
  ordinalString,
  getIsDependencyStart,
  getIsConstraintStart
};

export default timelineViewUtils;
